import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { purchaseUrl } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-72" data-mp="2ml8qz0hvg6nd">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 right-3 z-50 flex justify-center md:left-auto md:right-6" data-id="element-73" data-mp="2hpa79q7hncta">
          <a href={purchaseUrl} target="_blank" rel="noopener noreferrer" className="w-full rounded-2xl bg-accent px-6 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_16px_34px_rgba(241,96,13,.42)] transition-colors duration-150 ease-out hover:bg-accent-dark focus:outline-none focus:ring-4 focus:ring-accent/30 md:w-auto" data-id="element-74" data-mp="35el10nqf86xx">
            🏃 Quiero empezar mi plan · $19.990 →
          </a>
        </motion.div>}
    </AnimatePresence>;
}